module.exports = __webpack_public_path__ + "prod/1.42.2/img/faq3.1e989a26.png";